export default "__VITE_ASSET__5dc28d06__"